import React, { useState } from 'react';
import Header from './Header';
import FooterOther from './FooterOther';
import axios from "axios";
import Swal from "sweetalert2";



const RequestProposal = () => {
    const [cnpj, setCnpj] = useState('');
    const [localidade, setLocalidade] = useState('');
    const [periodo, setPeriodo] = useState('');
    const [telefone, setTelefone] = useState('');
    const [tipoServico, setTipoServico] = useState('');
    const [mensagem, setMensagem] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        const templateParams = {
            cnpj,
            localidade,
            telefone,
            tipoServico,
            mensagem,
        };

        try {
            const response = await axios.post("https://comercial.saudemovelbrasil.com/envio-email.php", templateParams, {
                headers: {
                    "Content-Type": "application/json", // Cabeçalho indicando JSON
                },
                withCredentials: false, // Incluir cookies, se necessário
            });

            if (response.data.success) {
                Swal.fire({
                    icon: "success",
                    title: "Sucesso!",
                    text: "E-mail enviado com sucesso.",
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Erro!",
                    text: response.data.message || "Erro ao enviar o e-mail.",
                });
            }
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Erro de Conexão!",
                text: "Não foi possível conectar à API. Verifique sua conexão ou tente novamente mais tarde.",
            });
            console.error("Erro ao conectar com a API:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const formatCNPJ = (value) => {
        // Remove caracteres não numéricos
        value = value.replace(/\D/g, '');

        // Limita o tamanho máximo a 14 caracteres (apenas números)
        if (value.length > 14) {
            value = value.slice(0, 14);
        }

        // Formata o CNPJ
        return value
            .replace(/^(\d{2})(\d)/, '$1.$2')       // Adiciona o primeiro ponto
            .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3') // Adiciona o segundo ponto
            .replace(/\.(\d{3})(\d)/, '.$1/$2')    // Adiciona a barra
            .replace(/(\d{4})(\d)/, '$1-$2');      // Adiciona o hífen
    };

    const handleCNPJChange = (e) => {
        const formattedCNPJ = formatCNPJ(e.target.value);
        setCnpj(formattedCNPJ);
    }
    const formatTelefone = (value) => {
        // Remove caracteres não numéricos
        value = value.replace(/\D/g, '');
        // Formata o telefone
        if (value.length > 11) {
            value = value.slice(0, 11);
        }
        return value.replace(/(\d{2})(\d)/, '($1) $2') // (99) 9
            .replace(/(\d{5})(\d)/, '$1-$2'); // (99) 99999-9999
    };

    const handleTelefoneChange = (e) => {
        const formattedTelefone = formatTelefone(e.target.value);
        setTelefone(formattedTelefone);
    };

    return (
        <div>
            <Header />
            <section className="request-proposal" id="solicitar-proposta">
                <div className="container ">
                    <div className="row py-5">
                        <div className="col-12 title">Unidade Móveis de Saúde para Locação</div>
                        <div className="pb-2"><span>Soluções Sob Medida para você!</span></div>
                        <div style={{ fontWeight: 'bold', fontSize: '30px' }}>Fale com a gente!</div>
                    </div>
                </div>
            </section>
            <section className="request-proposal-form" id="form-solicitar-proposta">
                <div className="container">
                    <div className="row py-5">
                        <div className="col-12 title">Solicite a sua proposta:</div>
                        <div className="py-4"><span>Tem dúvidas ou deseja mais informações?<br /> Estamos prontos para ajudar!</span></div>
                        <div className=""><span>Preencha o formulário abaixo e nossa equipe entrará em contato para apresentar como nossas unidades móveis podem atender às suas necessidades de forma personalizada.</span></div>
                    </div>
                    <form onSubmit={handleSubmit}> {/* Certifique-se de que o onSubmit esteja aqui */}
                        <div className="row">
                            <div className="col-12 pb-4">
                                <input
                                    className="form-control rounded-0 p-3"
                                    type="text"
                                    placeholder="CNPJ da Empresa/Organização"
                                    value={cnpj}
                                    onChange={handleCNPJChange}
                                />
                            </div>
                            <div className="col-12 py-4">
                                <input
                                    className="form-control rounded-0 p-3"
                                    type="text"
                                    placeholder="Localidade/Região"
                                    value={localidade}
                                    onChange={(e) => setLocalidade(e.target.value)}
                                />
                            </div>
                            <div className="col-lg-6 col-12 py-4">
                                <input
                                    className="form-control rounded-0 p-3"
                                    type="text"
                                    placeholder="Período de Locação"
                                    value={periodo}
                                    onChange={(e) => setPeriodo(e.target.value)}
                                />
                            </div>
                            <div className="col-lg-6 col-12 py-4">
                                <input
                                    className="form-control rounded-0 p-3"
                                    type="text"
                                    placeholder="Telefone para contato"
                                    value={telefone}
                                    onChange={handleTelefoneChange}
                                />
                            </div>
                            <div className="col-12 py-4">
                                <select className="form-control rounded-0 p-3" value={tipoServico} onChange={(e) => setTipoServico(e.target.value)}>
                                    <option value="">Tipo de Serviço Necessário</option>
                                    <option value="Prevenção & Saúde do Trabalhador">Prevenção & Saúde do Trabalhador</option>
                                    <option value="Saúde & Cuidado da Mulher">Saúde & Cuidado da Mulher</option>
                                    <option value="Tomografia">Tomografia</option>
                                    <option value="Serviços Básicos de Saúde">Serviços Básicos de Saúde</option>
                                </select>
                            </div>
                            <div className="col-12 py-4">
                                <textarea
                                    className="form-control rounded-0 p-3"
                                    placeholder="Escreva sua mensagem"
                                    value={mensagem}
                                    onChange={(e) => setMensagem(e.target.value)}
                                > </textarea>
                            </div>

                            <div className="col-12 py-4">
                                <button type="submit" disabled={isSubmitting} className="btn btn-warning text-uppercase d-block rounded-0 py-3" style={{ fontWeight: 'bold' }}>
                                    {isSubmitting ? 'Enviando...' : 'Solicitar'}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
            <FooterOther />
        </div>

    );
};

export default RequestProposal;